module.exports = __webpack_public_path__ + "static/media/ServiceNow_Step3_Image4.cd10c29c.jpg";